import * as types from '../mutation-types'
import * as consts from '../../data/base/consts'
import { API } from '../../api';

export default {
    namespaced: true,
    state: {
        gotSettingData: false,
        settingConfigData: {},
        curShowType: 1
    },
    getters: {},
    mutations: {
        [types.GLOBAL_SETTING_INIT_DATA](state) {
            if(state.gotSettingData) { return }
            API.getSettingConfig({}, function(data){
                console.log('获取基础配置信息::::::', data);
                state.gotSettingData = true;
                state.settingConfigData = data;
            });
        },
        // 轮流切换十神藏干的显示类型
        [types.GLOBAL_SETTING_TOGGLE_HIDE_TYPES](state) {
            var typeList = consts.CONST_SHISHEN_SHOW_TYPES;
            if(state.curShowType == (typeList.length - 1)) {
                state.curShowType = 0;
            }else{
                state.curShowType += 1;
            }
        }
    },
    actions: {
        initSettingData({ commit }) {
            commit(types.GLOBAL_SETTING_INIT_DATA)
        },
        toggleSetHideTypes({ commit }) {
            commit(types.GLOBAL_SETTING_TOGGLE_HIDE_TYPES)
        },
        /**
         * 修改设置数据
         * @param {修改内容的key和value} params 
         */
        updateSettingData({ state }, params) {
            API.updateSettingConfig(params, function(data) {
                console.log('修改设置数据成功:::::::', data)
                // 更新本地数据
                for(var keys in params) {
                    state.settingConfigData[keys] = data[keys];
                }
            })
        },
        resetData({ state }) {
            state.gotSettingData = false;
            state.settingConfigData = {};
            state.curShowType = 1;
        }
    }
}